import { animationTransition } from '@shared/utils/animationTransition';
import { Box, Flex, styled, StyleSystemProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const AccordionContainer = styled(Box)``;
const accordionContainerStyles: StyleSystemProps = {
  borderBottom: '1px solid',
  borderColor: 'mono3',
  maxWidth: '100%',
};

export const VisibleContentWrapper = styled(Box)``;
const visibleContentWrapperStyles: StyleSystemProps = {
  borderTop: '1px solid',
  borderBottom: '1px solid',
  marginY: pxToRem(-1),
  borderColor: 'transparent',
  transition: animationTransition('border-color'),
  _hover: {
    borderColor: 'white',
  },
};

export const VisibleContent = styled(Flex)``;
const visibleContentStyles: StyleSystemProps = {
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: pxToRem(8),
  transition: animationTransition('background-color'),
  _hover: {
    backgroundColor: 'mono2',
  },
  _active: {
    backgroundColor: 'mono3',
  },
};

export const CollapsedContent = styled(Box)``;
const collapsedContentStyles = (isOpen: boolean): StyleSystemProps => ({
  transition: 'min-height 300ms, padding 300ms',
  paddingBottom: isOpen ? 6 : 0,
  paddingTop: isOpen ? 4 : 0,
  minHeight: isOpen ? pxToRem(48) : 0,
  maxHeight: isOpen ? '100%' : 0,
  overflow: 'hidden',
});

export const ToggleButton = styled(Box)``;
const toggleButtonStyles = (isOpen: boolean): StyleSystemProps => ({
  padding: 3,
  transition: 'transform 500ms',
  transform: isOpen ? 'rotate(-180deg)' : 'rotate(0deg)',
});

export const styles = {
  accordionContainer: accordionContainerStyles,
  visibleContent: visibleContentStyles,
  collapsedContent: collapsedContentStyles,
  toggleButton: toggleButtonStyles,
  visibleContentWrapper: visibleContentWrapperStyles,
};
